import {
  actions,
  getTeamDataTableAsync,
  getUserByIdAsync,
  getUserRolesAsync,
  setUserEmailAsync,
  setUserPasswordAsync,
  softDeleteUserAsync,
  updateGenderAsync,
  unblockUserAsync,
  updateUserNameAsync,
  updateUserRolesAsync,
  blockUserAsync,
  createAdminAsync,
} from './slices';

export const TeamActions = {
  ...actions,
  getTeamDataTableAsync,
  getUserByIdAsync,
  getUserRolesAsync,
  setUserEmailAsync,
  setUserPasswordAsync,
  softDeleteUserAsync,
  updateGenderAsync,
  unblockUserAsync,
  updateUserNameAsync,
  updateUserRolesAsync,
  blockUserAsync,
  createAdminAsync,
};
